import React, { useEffect } from 'react'; 
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import vector from '../Assests/kioskImage/Vector.png';
import MainKioskInstrument from '../Assests/kioskImage/mainImage.png'

function Ayurai_Products({ scrollToQuery })  {
    const [ref, inView] = useInView({ threshold: 0.2 });
    const controlsBottom = useAnimation();
  
    useEffect(() => {
      if (inView) {
        controlsBottom.start({
          y: 0,
          opacity: 1,
          transition: { type: 'spring', stiffness: 100, damping: 25, duration: 1, delay: 0.5 },
        });
      } else {
        controlsBottom.start({ y: '100vh', opacity: 0 });
      }
    }, [inView, controlsBottom]);
    

    useEffect(() => {
        let params = new URL(document.location).searchParams;
        let emailTemplate = params.get("key");
        if (emailTemplate === "Newsletter") {
          MailTracker('KioskRegister');
        }
    
      }, []);
    
      const MailTracker = async (value) => {
        const payload = { key: value };
    
        try {
          const response = await fetch('https://api.tele.ayurai.in/NewsletterTracker', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          console.log(data);
        } catch (error) {
          console.error('Error:', error);
        }
      };
  
    return (
      <div className="background">
        <section>
          <div className="kiosk-products" ref={ref}>
            <div className="kiosk-content-wrapper">
              <motion.div
                animate={controlsBottom}
                initial={{ y: "100vh", opacity: 0 }}
                className="kiosk-mockup"
              >
                <img src={MainKioskInstrument} alt="Kiosk Mockup" />
              </motion.div>
            </div>
            <div className="overlay-top-right">
              <div className="app-more-info-item-new">
                <p>
                  Ayurveda Phenotyping & Personalized Recommendations
                </p>
                <a href="#button-navigate">
                  <button className="app-more-info-item-button" onClick={scrollToQuery}>
                    Enquire Us
                    <img src={vector} alt="icon" />
                  </button>
                </a>
                
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };

export default Ayurai_Products;
